import React from "react";
import disable from "../../asset/image/disable.svg";
import enable from "../../asset/image/enable.svg";
import {
  CONFIRM_DIALOG_TITLE,
  MARK_AS_USER_ENABLED_CONFIRM_DIALOG_SUBTITLE,
  MARK_AS_USER_DISABLED_CONFIRM_DIALOG_SUBTITLE,
} from "../../config";

interface UserDisableToggleProps {
  row: any;
  setConfirmDialog: (dialog: any) => void;
  onDisable: (row: any) => void;
  onEnable: (row: any) => void;
}

function UserDisableToggle({ row, setConfirmDialog, onDisable, onEnable }: UserDisableToggleProps) {
  if (row.userState !== "-") {
    return (
      <img
        className="icon-cursor"
        src={disable}
        style={{ height: "20px", width: "30px", marginBottom: "3px" }}
        title="Enable user"
        onClick={() => {
          setConfirmDialog({
            isOpen: true,
            title: CONFIRM_DIALOG_TITLE,
            subTitle: MARK_AS_USER_ENABLED_CONFIRM_DIALOG_SUBTITLE,
            onConfirm: () => {
              onEnable(row);
            },
          });
        }}
      />
    );
  }

  return (
    <img
      className="icon-cursor"
      src={enable}
      style={{ height: "20px", width: "30px", marginBottom: "3px" }}
      title="Disable user"
      onClick={() => {
        setConfirmDialog({
          isOpen: true,
          title: CONFIRM_DIALOG_TITLE,
          subTitle: MARK_AS_USER_DISABLED_CONFIRM_DIALOG_SUBTITLE,
          onConfirm: () => {
            onDisable(row);
          },
        });
      }}
    />
  );
}

export default UserDisableToggle;
